import { render, staticRenderFns } from "./AiAuditPanel.vue?vue&type=template&id=32cc070c&scoped=true&"
import script from "./AiAuditPanel.vue?vue&type=script&lang=js&"
export * from "./AiAuditPanel.vue?vue&type=script&lang=js&"
import style0 from "./AiAuditPanel.vue?vue&type=style&index=0&id=32cc070c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc070c",
  null
  
)

export default component.exports